import React from 'react';
import NotificationsIcon from '@material-ui/icons/Notifications';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';

export default function(props) {
    return (
        <IconButton aria-describedby='simple-popover' style={{color: 'white'}}>
            <Badge
                badgeContent={props.badgeContent}
                color="secondary"
                onClick={props.onClick}
            >
                <NotificationsIcon
                    className="no-print"
                    fontSize="large"
                    onClick={props.onClick}
                />
            </Badge>
        </IconButton>
    );
}
